import React from 'react'
import { Box, Grid, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const Preloader: React.FC = (): JSX.Element => {
  const classes = useStyles()
  return (
    <Grid container justifyContent="center" alignItems="center" className={classes.page}>
      <Grid item>
        <div className="loadingio-spinner-ripple-ebhm9ege9r7">
          <div className="ldio-p7r8fspzu69">
            <div></div>
            <div></div>
          </div>
        </div>
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles(({ spacing, font, breakpoints: { down }, palette }: Theme) => ({
  page: {
    height: '100vh',
  },
}))
